module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-edit-reporting-type"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Name"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.name),
      expression: "body.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "name", $event.target.value)
      }
    }
  })])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Description"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.description),
      expression: "body.description"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "description", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "switch small"
  }, [_c('label', [_vm._v("Position required")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.position_required),
      expression: "body.position_required"
    }],
    staticClass: "switch-input",
    attrs: {
      "id": "position-required",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.body.position_required) ? _vm._i(_vm.body.position_required, null) > -1 : (_vm.body.position_required)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.body.position_required,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.body, "position_required", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.body, "position_required", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.body, "position_required", $$c)
        }
      }
    }
  }), _vm._m(0)])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "switch small"
  }, [_c('label', [_vm._v("Attachment required")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.attachment_required),
      expression: "body.attachment_required"
    }],
    staticClass: "switch-input",
    attrs: {
      "id": "attachment_required",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.body.attachment_required) ? _vm._i(_vm.body.attachment_required, null) > -1 : (_vm.body.attachment_required)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.body.attachment_required,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.body, "attachment_required", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.body, "attachment_required", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.body, "attachment_required", $$c)
        }
      }
    }
  }), _vm._m(1)])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns actions"
  }, [_c('button', {
    staticClass: "button small",
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch-paddle",
    attrs: {
      "for": "position-required"
    }
  }, [_c('span', {
    staticClass: "show-for-sr"
  }, [_vm._v("Position required")]), _c('span', {
    staticClass: "switch-active",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("Yes")]), _c('span', {
    staticClass: "switch-inactive",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "switch-paddle",
    attrs: {
      "for": "attachment_required"
    }
  }, [_c('span', {
    staticClass: "show-for-sr"
  }, [_vm._v("Attachment required")]), _c('span', {
    staticClass: "switch-active",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("Yes")]), _c('span', {
    staticClass: "switch-inactive",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("No")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75cb3361!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/EditReportingType.vue
// module id = 2443
// module chunks = 1